import React from 'react';
import { Typography, Tooltip } from '@mui/material';

import TurnedInIcon from '@mui/icons-material/TurnedIn';
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';

export const CommonLabel = ({ textColor, bgColor, text }) => {
  return (
    <Typography
      sx={{
        maxWidth: 'fit-content',
        minWidth: '100px',
        borderRadius: '6px',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        justifyContent: 'center',
        fontSize: '0.85rem',
        padding: '0 6px',
        textAlign: 'center',
        fontWeight: '700',
        color: textColor,
        backgroundColor: bgColor,
      }}
    >
      {text}
    </Typography>
  );
};

export const MembershipCardIcon = ({ data }) => {
  const setTooltipTitle = () => {
    if (data.current_campcard && data.current_campcard_payed) {
      return 'Tessera attiva e pagata';
    }
    if (data.current_campcard && !data.current_campcard_payed) {
      return 'Tessera attiva e non pagata';
    }
    if (!data.current_campcard && data.last_campcard && data.last_campcard_payed) {
      return 'Tessera da rinnovare';
    }
    if (!data.current_campcard && !data.last_campcard && data.had_card) {
      return 'Ex Iscritto';
    }

    return 'Non Tesserato';
  };

  const getTooltipIcon = () => {
    if (data.current_campcard && data.current_campcard_payed) {
      return <TurnedInIcon sx={{ color: '#47ba25' }} />;
    }
    if (data.current_campcard && !data.current_campcard_payed) {
      return <TurnedInIcon sx={{ color: '#329dd6' }} />;
    }
    if (!data.current_campcard && data.last_campcard && data.last_campcard_payed) {
      return <TurnedInIcon sx={{ color: '#ffa500' }} />;
    }
    if (!data.current_campcard && !data.last_campcard && data.had_card) {
      return <TurnedInIcon sx={{ color: '#808080' }} />;
    }

    return <TurnedInNotIcon sx={{ color: '#9fa1a2' }} />;
  };

  return (
    <Tooltip arrow placement="right" title={setTooltipTitle()}>
      {getTooltipIcon()}
    </Tooltip>
  );
};
